import { useEffect, useRef } from "react";
import axios from "axios";
import type { AxiosRequestConfig } from "axios";
import { activityAddOnPurchaseListUrl } from "../../../utils/constant";
import type { AddOnPurchaseListRequest, AddOnPurchasePage } from "./types";

interface ListResult { status: string; data: AddOnPurchasePage; message?: string; }
export function useAddOnPurchaseRequest(identity: string) {
  const latestIdentity = useRef(identity);
  latestIdentity.current = identity;
  const controller = useRef<AbortController>();
  useEffect(() => () => { controller.current?.abort(); }, []);
  const fetchProducts = async (request: AddOnPurchaseListRequest, headers: AxiosRequestConfig["headers"]) => {
    controller.current?.abort();
    const activeController = new AbortController();
    controller.current = activeController;
    const requestIdentity = identity;
    try {
      const response = await axios.post<ListResult>(activityAddOnPurchaseListUrl, request,
        { headers, signal: activeController.signal });
      if (activeController.signal.aborted || latestIdentity.current !== requestIdentity) return undefined;
      if (response.data.status !== "success") throw new Error(response.data.message || "Product list request failed");
      return response;
    } catch (error) {
      if (activeController.signal.aborted || latestIdentity.current !== requestIdentity) return undefined;
      throw error;
    }
  };
  return fetchProducts;
}
